import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface NotificationState {
  isLoading: boolean;
  isInitialLoading: boolean;
  notificationData: {
    show: boolean;
    title: string | null;
    description: string | undefined;
    type?: string;
    duration: number | undefined;
  };
}

const initialState: NotificationState = {
  isLoading: false,
  isInitialLoading: true,
  notificationData: {
    show: false,
    type: undefined,
    title: null,
    description: undefined,
    duration: undefined,
  },
};

const notificationSlice = createSlice({
  name: "notification",
  initialState,
  reducers: {
    toggleLoading(state, action) {
      state.isLoading = action.payload;
    },
    toggleInitalLoading(state, action) {
      state.isInitialLoading = action.payload;
    },
    toggleNotification(
      state,
      action: PayloadAction<{
        title: string;
        description?: string;
        type: string;
        duration: number;
      }>
    ) {
      if (action.payload) {
        state.notificationData.show = true;
        state.notificationData.title = action.payload.title;
        state.notificationData.description = action.payload.description;
        state.notificationData.type = action.payload.type;
        state.notificationData.duration = action.payload.duration;
      } else {
        state.notificationData.show = false;
        state.notificationData.title = null;
        state.notificationData.description = undefined;
        state.notificationData.type = undefined;
        state.notificationData.duration = undefined;
      }
    },
  },
});

export const notificationActions = notificationSlice.actions;

export default notificationSlice.reducer;
